import React from 'react';
import config from "./config";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import {BrowserRouter as Router, Route, Routes} from "react-router-dom";
import reportWebVitals from "./reportWebVitals";
import store from "./redux/configure-store";
import App from "./App";
// import App from './App';
import "./styles/scrollbar.css";
import "./styles/index.css";
import AuthConfig from "./pages/auth-action/auth-config";
import AuthCallback from "./pages/auth-action/auth-callback";

if (config.IS_PRODUCTION) {
    console.log = () => {}
    console.debug = () => {}
}

ReactDOM.render(
  <React.StrictMode>
    <Router>
      <Provider store={store}>
          <Routes>
              <Route path='/' element={<App/>} />
              <Route path='/auth-callback' element={<AuthConfig userCache={true}><AuthCallback/></AuthConfig>} />
          </Routes>
      </Provider>
    </Router>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
